import { render, staticRenderFns } from "./BoardFeatureSelected.vue?vue&type=template&id=53e5f9c0&scoped=true&lang=pug&"
import script from "./BoardFeatureSelected.vue?vue&type=script&lang=js&"
export * from "./BoardFeatureSelected.vue?vue&type=script&lang=js&"
import style0 from "./BoardFeatureSelected.vue?vue&type=style&index=0&id=53e5f9c0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e5f9c0",
  null
  
)

export default component.exports